import React from 'react';
import { clsx } from 'clsx';
import { AdacText } from '@adac-de/component-library';
import { useIsBreakpoint } from '@hooks/use-is-breakpoint';
import { Breakpoints } from '@utils/breakpoints';

export const FormLegend: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isDesktop = useIsBreakpoint(Breakpoints.S);
  return (
    <legend>
      <AdacText
        type={isDesktop ? 'large' : 'normal'}
        className={clsx('margin-bottom--s', 'margin-top--s')}
      >
        {children}
      </AdacText>
    </legend>
  );
};
